define('modules/start/products/trans/info/view',['require','exports','module','env','views/BaseView','ldsh!./template'],function(require, exports, module) {
    "use strict";

    var Config = require("env");
    var BaseView = require("views/BaseView");

    var Layout = BaseView.extend({
        template: require("ldsh!./template"),

        initialize: function() {
            if(this.productDetails) {
                this.listenTo(this.productDetails, "sync", this.render);
            }
        },

        serialize: function() {
            return {
                active: this.active,
                isStarter: this.checkIfAccountIsStarter(),
                paymentsUrl: Config.paymentsUrl + 'account/products',
            };
        },

        checkIfAccountIsStarter: function () {            
            return this.servicePlan === 'starter';
        }
    });

    module.exports = Layout;
});

